<template>
  <a-modal 
  :width="800"
  maskClosable
  centered
  :visible="visible" 
  title="选择标签" 
  @cancel="cancel"
  @ok="handleOk">
    <div class="choose-tag">
      <div class="tag-cate-row" v-for="(val,key) in allTags" :key="key">
        <h4 class="title-color">{{key}}</h4>
        <a-tag v-for="tag in val" :class="{'tag-choosed': choosedTagIds.includes(tag.id)}" :key="tag.id" @click="clickTag(tag)">
          {{ tag.tagName }}
        </a-tag>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { getTagList } from '@/utils/api'

export default {
  name: 'ChooseTag',
  props: {
    // 显示隐藏
    value: {
      type: Boolean, 
      default: false,
    },
    // 已选择的 tag 数组
    list: {
      type: Array, 
      default: ()=> [],
      required: true
    }
  },
  created() {
    // 获取tag列表
    this.getList()
  },
  data() {
    return {
      allTags: {
        '前端开发': [
          { id: '123', groupName: '前端开发', tagName: 'html' },
          { id: '124', groupName: '前端开发', tagName: 'css' },
          { id: '125', groupName: '前端开发', tagName: 'js' },
          { id: '126', groupName: '前端开发', tagName: 'vue' },
          { id: '127', groupName: '前端开发', tagName: 'react' },
          { id: '128', groupName: '前端开发', tagName: 'webpack' },
        ],
        '服务端开发': [
          { id: '223', groupName: '服务端开发', tagName: 'java' },
          { id: '224', groupName: '服务端开发', tagName: 'C++' },
          { id: '225', groupName: '服务端开发', tagName: 'python' },
          { id: '226', groupName: '服务端开发', tagName: 'C#' },
          { id: '227', groupName: '服务端开发', tagName: 'php' },
          { id: '228', groupName: '服务端开发', tagName: 'Golang' }
        ],
        '工业应用组件': [
          { id: '323', groupName: '工业应用组件', tagName: 'twork' },
          { id: '324', groupName: '工业应用组件', tagName: 'Poros' },
          { id: '325', groupName: '工业应用组件', tagName: '流程引擎' },
          { id: '326', groupName: '工业应用组件', tagName: 'geekworks' },
          { id: '327', groupName: '工业应用组件', tagName: 'T信' },
          { id: '328', groupName: '工业应用组件', tagName: 'MFA' }
        ]
      },
      visible: false,
      choosedTags: [],
    }
  },
  computed: {
    choosedTagIds() {
      return this.choosedTags.map(tag => tag.id)
    }
  },
  watch: {
    value(n) {
      this.visible = n
      if(n) this.choosedTags = [...this.list]
    },
    visible: {
      handler() {
        if (this.visible) {
          this.getList()
        }
      },
      immediate: true
    }
  },
  methods: {
    getList() {
      getTagList().then(res=> {
        if(res.code===0) {
          this.allTags = res.data
        }
      })
    },
    // 点击选中/取消选中 tag
    clickTag(tag) {
      const tagId = tag.id
      if(this.choosedTagIds.includes(tagId)) {
        this.choosedTags = this.choosedTags.filter(tag => tag.id !== tagId)
      } else {
        this.choosedTags.push(tag)
      }
      this.$forceUpdate()
    },
    // 点击确定
    handleOk() {
      if(this.choosedTagIds.length === 0) {
        this.$message.error('请至少选择1个标签')
        return
      }
      if(this.choosedTagIds.length > 5 ) {
        this.$message.error('最多选择5个标签')
        return
      }
      this.$emit('change', Array.from(this.choosedTags))
      this.$emit('input',false)
    },
    cancel() {
      this.$emit('input',false)
    }
  }
}
</script>
<style lang="less" scoped>
.choose-tag {
  position: relative;
  .tag-cate-row {
    margin-bottom: 20px;
    .title-color {
      margin-bottom: 12px;
      font-size: 14px;
      color: #040C2C;
      line-height: 22px;
      font-weight: 500;
    }
    .ant-tag {
      margin-bottom: 10px;
      margin-right: 10px;
      cursor: pointer;
    }
    .tag-choosed {
      color: #1890FF ;
      background: #E0F0FF;
      border: 1px solid rgba(123,191,255,1);
    }
  } 
}
</style>